import { useState } from "react";
import PropTypes from "prop-types";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import useAuthorized from "hooks/useAuthorized";
import { useCustomEmailDomainMutations } from "hooks/useCustomEmailDomainsTable";
import DomainModal from "./DomainModal";

export function CustomEmailDomainsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const canEdit = useAuthorized([ACL_RELATIONSHIPS.customEmailDomains.update]);
  const canDelete = useAuthorized([
    ACL_RELATIONSHIPS.customEmailDomains.delete,
  ]);

  const { remove } = useCustomEmailDomainMutations({
    onDeleted: () => setDeleteOpen(false),
  });

  if (!canEdit && !canDelete) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Custom email domain actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <DomainModal
        open={editOpen}
        onOpenChange={setEditOpen}
        domain={original}
      />
      <ConfirmDeleteDialog
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        title="Delete custom email domain?"
        description="Are you sure you want to delete this Custom Email Domain?"
        onConfirm={() => !remove.isPending && remove.mutate(original.id)}
      />
    </>
  );
}

CustomEmailDomainsTableActions.propTypes = {
  original: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};
